/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * OTEL log body
 */
export type OTELLogBody = {
  /**
   * String body value
   */
  stringValue?: string | undefined;
};

/** @internal */
export type OTELLogBody$Outbound = {
  stringValue?: string | undefined;
};

/** @internal */
export const OTELLogBody$outboundSchema: z.ZodMiniType<
  OTELLogBody$Outbound,
  OTELLogBody
> = z.object({
  stringValue: z.optional(z.string()),
});

export function otelLogBodyToJSON(otelLogBody: OTELLogBody): string {
  return JSON.stringify(OTELLogBody$outboundSchema.parse(otelLogBody));
}
